import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ImageSize = keyof typeof SIZES;

export const SIZES = {
    "large": [2560, 1440],
    "normal": [1920, 1080],
    "tablet": [1280, 720],
    "phone": [800, 480],
} as const;

interface ExportState {
    imageSize: ImageSize;
}

const initialState: ExportState = {
    imageSize: 'normal',
};

export const exportSlice = createSlice({
    name: 'export',
    initialState,
    reducers: {
        setImageSize: (state, action: PayloadAction<ImageSize>) => {
            state.imageSize = action.payload;
        },
    },
});

export const { setImageSize } = exportSlice.actions;
